export default __webpack_public_path__ + "static/media/penjualan-barang.9f32a322.png";